export default {
  updateEventPreviewUrl(state, url) {
    state.event = { ...state.event, ...{ preview_url: url } };
  },
  updateEventContent(state, payload) {
    state.event = { ...state.event, ...payload };
  },
  updateSingleEventQuestion(state, { question }) {
    // question.index is dynamic due to drag and drop reordering
    const questionIndex = state.event.questions.findIndex((q) => q.index === question.index);
    state.event.questions[questionIndex] = question;
  },
  setInteractionTypes(state, data) {
    state.lists.dataInteractionTypes = data;
  },
  updateIntegrations(state, data) {
    state.event.integrations = data.data;
    state.lists.integrations = data.meta.availableIntegrations;
  },
};
